export default __webpack_public_path__ + "static/media/howToGoPractice.8663ba30.png";